import { render, staticRenderFns } from "./ChromeBallBG.vue?vue&type=template&id=2e8555aa&"
import script from "./ChromeBallBG.vue?vue&type=script&lang=js&"
export * from "./ChromeBallBG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports